// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"2151d92f","763":"4cc15c6a","971":"d6bf8e70"}[chunkId] + ".chunk.css";
};